import {
  ApiRoute,
  PageData,
  PageDataSchema,
  PageReq,
  UserRankHistory,
  UserRankHistorySchema,
  UserRankSnapshotResp,
  UserRankSnapshotSchema,
  getApiRoute
} from "@garther/interfaces";
import { z } from "zod";

import { ApiClientConfig, BaseApiClient } from "./base-client";

const UserRankSnapshotRespSchema = UserRankSnapshotSchema.extend({
  pointsToNextRank: z.number().int()
});

export class UserRankApiClient extends BaseApiClient {
  constructor(config: ApiClientConfig) {
    super({
      ...config,
      baseEndpoint: getApiRoute(ApiRoute.USER_RANK),
      requireAuth: true
    });
  }

  async getSnapshot(): Promise<UserRankSnapshotResp> {
    return await this.get("me/snapshot", UserRankSnapshotRespSchema);
  }

  async getRankHistory(query: PageReq = { page: 0, limit: 20 }): Promise<PageData<UserRankHistory>> {
    return await this.get("me/history", PageDataSchema(UserRankHistorySchema), {
      params: query
    });
  }
}
